import React, { PureComponent } from 'react'
import { Jumbotron } from 'reactstrap'

class SessaoExpirada extends PureComponent {    
    render() {
        return (
            <div className="container">
                <Jumbotron>
                    <h1>Sessão expirada</h1>
                    <p className="mb-0">Por favor efetue o acesso novamente pelo DPNet.</p>
                    <p className="mt-0">Após acesso, pode-se utilizar o F5 nesta página ou simplesmente o menu do DPNet.</p>
                </Jumbotron>

            </div>
        )
    }
}

export default SessaoExpirada
